var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var AiUpperCaseIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 64
  }), React.createElement("path", {
    d: "M24.5333 19.8799L14.1333 43.2132H19.6667L21.7467 38.2132H32.56L34.6333 43.2132H40.3L29.8667 19.8799H24.5333ZM23.4533 34.1132L27.1667 25.1865L30.8667 34.1132H23.4533Z"
  }), React.createElement("path", {
    d: "M46.8 19.8799H41.4V43.2132H46.8V19.8799Z"
  }), React.createElement("path", {
    d: "M32 58.6667C24.88 58.6667 18.18 55.8933 13.1467 50.8533C2.74665 40.4533 2.74665 23.54 13.1467 13.14C18.18 8.10667 24.88 5.32667 32 5.32667C39.12 5.32667 45.82 8.1 50.8533 13.14L54.6267 9.36667C48.38 3.12667 40.1867 0 32 0C23.8133 0 15.62 3.12667 9.37332 9.37333C-3.12668 21.8733 -3.12668 42.1333 9.37332 54.6267C15.62 60.8733 23.8133 64 32 64C40.1867 64 48.38 60.8733 54.6267 54.6267L50.8533 50.8533C45.82 55.8867 39.12 58.6667 32 58.6667Z"
  }), React.createElement("path", {
    d: "M63.8334 19.8C60.7 19.1 58.24 16.6333 57.5334 13.5C57.4867 13.28 57.18 13.28 57.1267 13.5C56.4267 16.6333 53.96 19.0933 50.8267 19.8C50.6067 19.8466 50.6067 20.1533 50.8267 20.2066C53.96 20.9066 56.42 23.3733 57.1267 26.5066C57.1734 26.7266 57.48 26.7266 57.5334 26.5066C58.2334 23.3733 60.7 20.9133 63.8334 20.2066C64.0534 20.16 64.0534 19.8533 63.8334 19.8Z"
  }));
};
export var AiUpperCaseIconGlyph = function (props) {
  return React.createElement(AiUpperCaseIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};